import { useState } from "react";
import { Form, required, useNotify } from "ra-core";
import type { FieldValues, SubmitHandler } from "react-hook-form";
import { TextInput } from "@/components/admin/text-input";
import { Button } from "@/components/ui/button";
import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";
import { Layout } from "@/components/supabase/layout";

export const SetPasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const notify = useNotify();

  const handleSetPassword: SubmitHandler<FieldValues> = async (values) => {
    try {
      setLoading(true);

      const { error } = await supabase.auth.updateUser({
        password: values.password,
        data: { is_invited_user: false }, // Clear the flag
      });

      if (error) throw error;

      // Mark email as confirmed in the sales table so they don't get forced here again
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (user) {
        await supabase
          .from("sales")
          .update({ email_confirmed_at: new Date().toISOString() })
          .eq("user_id", user.id);
      }

      notify("Password set successfully! Welcome to Mojo.", {
        type: "success",
      });
      window.location.href = "/#/";
    } catch (error: any) {
      notify(error.message || "Failed to set password", { type: "warning" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="flex flex-col space-y-2 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">
          Secure your account
        </h1>
        <p className="text-muted-foreground text-sm">
          You're logged in via verification code. Please set a password to
          continue.
        </p>
      </div>

      <Form onSubmit={handleSetPassword} className="space-y-8 mt-6">
        <TextInput
          label="New Password"
          source="password"
          type="password"
          validate={required()}
          autoComplete="new-password"
        />
        <Button
          type="submit"
          className="cursor-pointer w-full"
          disabled={loading}
        >
          {loading ? "Saving..." : "Set Password & Continue"}
        </Button>
      </Form>
    </Layout>
  );
};

SetPasswordPage.path = "set-password";
